import { createContext, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { AddonDTO, SubscriptionDTO } from '../../Types/Billing';
import { useBookitupSubscription } from '../hooks/useBookitupSubscription';
import { ChargebeeS } from '../ChargebeeS';

interface BookitupSubscriptionContextInterface {
  subscription?: SubscriptionDTO;
  resourceAddon: AddonDTO | null;
  refresh: () => void;
  loading: boolean;
  openPortal: () => void;
}

export const BookitupSubscriptionContext = createContext<BookitupSubscriptionContextInterface>(
  {} as BookitupSubscriptionContextInterface,
);

export const BookitupSubscriptionProvider = () => {
  const { loading, refresh, subscription, resourceAddon } = useBookitupSubscription();

  const openPortal = () => ChargebeeS.openPortal(refresh);

  const value = useMemo(
    () => ({
      loading,
      resourceAddon,
      refresh,
      subscription,
      openPortal,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading, refresh, subscription, resourceAddon],
  );

  return (
    <BookitupSubscriptionContext.Provider value={value}>
      <Outlet />
    </BookitupSubscriptionContext.Provider>
  );
};
